// extracted by mini-css-extract-plugin
export default {"l":"_060348fc12"};